var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCard from '@material-ui/core/Card';
/**
 * Kareo wrapped component of the Material-UI Card. The prop API has been limited to props defined in CardProps.
 *
 * Cards contain content and actions about a single subject.
 *
 * Material-UI Card: [Docs](https://v4.mui.com/components/cards/), [API](https://v4.mui.com/api/card/)
 *
 * @storybook: [Card](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-card--card-example)
 */
var Card = React.forwardRef(function (props, ref) {
    return React.createElement(MuiCard, __assign({}, props, { ref: ref }));
});
Card.defaultProps = {
    variant: 'elevation',
    square: false,
    raised: false,
};
Card.displayName = 'KareoCard';
export default Card;
